module.exports = __webpack_public_path__ + "img/look.aadce2b8.svg";